// extracted by mini-css-extract-plugin
export default {"content":"style_content__bl9BC","itemName":"style_itemName__7Gyvj"};